import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { RecognizeResponse } from '../../../types/api';
import { Bonus } from '../lib/bonus';
import { ReactionData } from '../types';

export const useBonusReactions = (bonus: Bonus) => {
	const http = useHttpClient('v2');
	return useQuery(
		['reactions', bonus.id],
		() => {
			return http.get<RecognizeResponse<ReactionData[]>>('reactions', {
				params: {
					bonus_id: bonus.id,
				},
			});
		},
		{
			select: (data) => data.data.result,
		}
	);
};
